(function (root, factory) {
  var moduleValue = factory();
  if (typeof module === 'object' && module.exports) module.exports = moduleValue;
  else root.SAModalMotion = moduleValue.createModalMotion(root);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var ROOT_ATTR = 'data-sa-modal-motion';
  var STATE_ATTR = 'data-sa-modal-motion-state';
  var BACKDROP_SELECTOR = '[data-sa-modal-motion-backdrop]';
  var PANEL_SELECTOR = '[data-sa-modal-motion-panel]';

  function parseTime(value) {
    var text = String(value || '').trim();
    if (!text) return 0;
    var amount = parseFloat(text);
    if (!Number.isFinite(amount)) return 0;
    return text.slice(-2) === 'ms' ? amount : amount * 1000;
  }

  function longestTransition(style) {
    if (!style) return 0;
    var durations = String(style.transitionDuration || '0s').split(',').map(parseTime);
    var delays = String(style.transitionDelay || '0s').split(',').map(parseTime);
    var count = Math.max(durations.length, delays.length);
    var longest = 0;
    for (var index = 0; index < count; index += 1) {
      longest = Math.max(longest, durations[index % durations.length] + delays[index % delays.length]);
    }
    return longest;
  }

  function createModalMotion(win) {
    var records = new WeakMap();

    function valid(root) {
      if (!root || typeof root.hasAttribute !== 'function' || !root.hasAttribute(ROOT_ATTR)) return false;
      if (String(root.tagName || '').toLowerCase() === 'dialog') return true;
      return Boolean(root.querySelector(BACKDROP_SELECTOR) && root.querySelector(PANEL_SELECTOR));
    }

    function recordFor(root) {
      var record = records.get(root);
      if (!record) {
        record = { frame: 0, timer: 0, version: 0 };
        records.set(root, record);
      }
      return record;
    }

    function cancelPending(record) {
      if (record.frame) win.cancelAnimationFrame(record.frame);
      if (record.timer) win.clearTimeout(record.timer);
      record.frame = 0;
      record.timer = 0;
      record.version += 1;
    }

    function closingDuration(root) {
      if (!win.getComputedStyle) return 0;
      var targets = [];
      var backdrop = root.querySelector && root.querySelector(BACKDROP_SELECTOR);
      var panel = root.querySelector && root.querySelector(PANEL_SELECTOR);
      if (backdrop) targets.push([backdrop, null]);
      if (panel) targets.push([panel, null]);
      if (String(root.tagName || '').toLowerCase() === 'dialog') {
        targets.push([root, null], [root, '::backdrop']);
      }
      return targets.reduce(function (longest, target) {
        try { return Math.max(longest, longestTransition(win.getComputedStyle(target[0], target[1]))); }
        catch (error) { return longest; }
      }, 0);
    }

    function open(root) {
      if (!valid(root)) return false;
      var record = recordFor(root);
      cancelPending(record);
      var version = record.version;
      root.setAttribute(STATE_ATTR, 'opening');
      if (typeof root.getBoundingClientRect === 'function') root.getBoundingClientRect();
      record.frame = win.requestAnimationFrame(function () {
        record.frame = 0;
        if (record.version !== version || !root.isConnected) return;
        root.setAttribute(STATE_ATTR, 'open');
      });
      return true;
    }

    function close(root, finish) {
      if (!valid(root)) return false;
      var record = recordFor(root);
      cancelPending(record);
      var version = record.version;
      root.setAttribute(STATE_ATTR, 'closing');
      var wait = closingDuration(root);
      record.timer = win.setTimeout(function () {
        record.timer = 0;
        if (record.version !== version) return;
        root.removeAttribute(STATE_ATTR);
        if (typeof finish === 'function') finish();
      }, wait ? wait + 34 : 0);
      return true;
    }

    return Object.freeze({ open: open, close: close });
  }

  return { createModalMotion: createModalMotion };
});
